/* eslint-disable */
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Button } from '@material-ui/core';
import IconCancel from '@material-ui/icons/Cancel';
import Description from '@material-ui/icons/Description';
import IconDelete from '@material-ui/icons/Delete';

import React, { useState } from 'react';
import { Datagrid, List, FunctionField, useRefresh } from 'react-admin';
import ScheduleListPagination from './ScheduleListPagination';
import { CustomDateField } from '../../commonComponents/DateField';
import { serverApiUrl } from '../../config/constants';
import httpClient from '../../core/httpClient';
import PreSignedUrlField from '../../commonComponents/PreSignedUrlField';
const ScheduleList = (props) => (
  <List
    title="Schedule list"
    bulkActionButtons={false}
    sort={{ field: 'created_at', order: 'DESC' }}
    pagination={<ScheduleListPagination />}
    {...props}
  >
    <Datagrid>
      <CustomDateField label="Schedule Date" source="date" sortable={false} style={{ fontSize: '13px' }} />
      <FunctionField label="Data" render={(render) => <MoreInfo schedule={render} />} style={{ fontSize: '13px' }} />
      <FunctionField
        label="Type"
        render={(render) => <ScheduleType schedule={render} />}
        style={{ fontSize: '13px' }}
      />
      <FunctionField
        label="Published"
        render={(render) => (render.published ? 'Yes' : 'No')}
        style={{ fontSize: '13px' }}
      />
      <FunctionField
        label="Delete"
        render={(render) => <DeleteSchedule schedule={render} />}
        style={{ fontSize: '13px' }}
      />
    </Datagrid>
  </List>
);

const ScheduleType = ({ schedule }) => {
  const type = schedule.schedule_type;

  if (type === 'message') {
    return (
      <div>
        Send message (
        {schedule?.body?.type === 19 ? (
          schedule?.body?.target_group_id ? (
            <span style={{ whiteSpace: 'nowrap' }}>Target group: {schedule?.body?.target_group_id}</span>
          ) : (
            <span style={{ whiteSpace: 'nowrap' }}>All users</span>
          )
        ) : (
          <span style={{ whiteSpace: 'nowrap' }}>{schedule?.body?.user_id}</span>
        )}
        )
      </div>
    );
  }

  if (type === 'article') {
    return (
      <div>
        Send article (
        {schedule?.meta?.type === 'all' ? (
          'All users'
        ) : schedule?.meta?.type === 'single' ? (
          `${schedule?.body?.user_id}`
        ) : (
          <span style={{ whiteSpace: 'nowrap' }}>Target group: {schedule?.body?.target_group_id}</span>
        )}
        )
      </div>
    );
  }

  if (type === 'coupon' || type === 'product' || type === 'present') {
    return (
      <div>
        {schedule?.meta?.type === 'create' ? 'Create' : schedule?.meta?.type === 'update' ? 'Update' : ''} {type}
      </div>
    );
  }

  return <div></div>;
};

const MoreInfo = ({ schedule }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpenModal = (e) => {
    e.stopPropagation();
    setIsOpen(true);
  };

  const handleCloseModal = () => {
    setIsOpen(false);
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
      <div>
        {schedule?.schedule_type === 'article' && (
          <div>
            <div>
              <span style={{ fontWeight: 'bold' }}>Caption: </span>
              <span>{schedule?.body?.caption}</span>
            </div>
            <div>
              <span style={{ fontWeight: 'bold' }}>Message: </span>
              <span>{schedule?.body?.message}</span>
            </div>
          </div>
        )}

        {schedule?.schedule_type === 'message' && (
          <div>
            <span style={{ fontWeight: 'bold' }}>Text: </span>
            <span>{schedule?.body?.message?.text}</span>
          </div>
        )}

        {schedule?.schedule_type === 'coupon' && (
          <div>
            {schedule?.body?.product_id && (
              <div>
                <span style={{ fontWeight: 'bold' }}>Product ID: </span>
                <span>{schedule?.body?.product_id}</span>
              </div>
            )}
            {schedule?.body?.pdf_link && (
              <div>
                <span style={{ fontWeight: 'bold' }}>PDF link: </span>
                <span style={{ cursor: 'pointer' }}>
                  <PreSignedUrlField
                    label="PDF link"
                    record={{
                      pdf_link: schedule?.body?.pdf_link,
                    }}
                    source="pdf_link"
                  />
                </span>
              </div>
            )}
            {schedule?.body?.code && (
              <div>
                <span style={{ fontWeight: 'bold' }}>Code: </span>
                <span>{schedule?.body?.code}</span>
              </div>
            )}
            {schedule?.body?.nominal_value && (
              <div>
                <span style={{ fontWeight: 'bold' }}>Nominal value: </span>
                <span>{schedule?.body?.nominal_value}</span>
              </div>
            )}
            {schedule?.body?.coupon_codes_link && (
              <div>
                <span style={{ fontWeight: 'bold' }}>Coupon codes link: </span>
                <span style={{ cursor: 'pointer' }}>
                  <PreSignedUrlField
                    label="Coupon codes link"
                    record={{
                      coupon_codes_link: schedule?.body?.coupon_codes_link,
                    }}
                    source="coupon_codes_link"
                  />
                </span>
              </div>
            )}
          </div>
        )}

        {schedule?.schedule_type === 'present' && (
          <div>
            <div>
              <span style={{ fontWeight: 'bold' }}>Name: </span>
              <span>{schedule?.body?.name}</span>
            </div>
            <div>
              <span style={{ fontWeight: 'bold' }}>Description: </span>
              <span>{schedule?.body?.description}</span>
            </div>
          </div>
        )}

        {schedule?.schedule_type === 'product' && (
          <div>
            <div>
              <span style={{ fontWeight: 'bold' }}>Description: </span>
              <span>{schedule?.body?.description}</span>
            </div>
            <div>
              <span style={{ fontWeight: 'bold' }}>Provider ID: </span>
              <span>{schedule?.body?.provider_id}</span>
            </div>
          </div>
        )}
      </div>

      <div style={{ transform: 'scale(0.8)' }}>
        <IconButton onClick={handleOpenModal} size="small">
          <Description />
        </IconButton>
      </div>

      <Dialog open={isOpen} onClick={(e) => e.stopPropagation()}>
        <DialogContent>
          <div>
            <pre>{JSON.stringify(schedule?.body, null, 2)}</pre>
          </div>
        </DialogContent>

        <DialogActions>
          <Button label="Close" onClick={handleCloseModal}>
            <IconCancel />
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

const DeleteSchedule = ({ schedule }) => {
  const [isOpen, setIsOpen] = useState(false);
  const refresh = useRefresh();

  const handleOpenModal = (e) => {
    e.stopPropagation();
    setIsOpen(true);
  };

  const handleCloseModal = () => {
    setIsOpen(false);
  };

  const deleteSchedule = () => {
    const url = `${serverApiUrl}/admin/schedule`;
    const body = JSON.stringify({ id: schedule.id });
    const options = { method: 'DELETE', body };

    httpClient(url, options)
      .then(() => {
        refresh();
        handleCloseModal();
      })
      .catch(() => notify('Error: Failed to delete schedule', 'warning'));
  };

  return (
    <div>
      <IconButton color="secondary" onClick={handleOpenModal}>
        <IconDelete />
      </IconButton>
      <Dialog open={isOpen} onClick={(e) => e.stopPropagation()}>
        <DialogContent>
          <DialogTitle>Are you sure you want to delete this schedule?</DialogTitle>
        </DialogContent>

        <DialogActions>
          {/* <SaveButton disabled={submitting || pristine} handleSubmitWithRedirect={handleSubmitWithRedirect} /> */}
          <Button label="ra.action.cancel" onClick={handleCloseModal}>
            <IconCancel style={{ marginRight: '5px' }} /> Cancel
          </Button>

          <Button color="secondary" label="Delete" onClick={deleteSchedule}>
            <IconDelete style={{ marginRight: '3px' }} /> Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ScheduleList;
